import ReactGA from "react-ga";
import React from "react";
import {
  Table,
  Tabs,
  Icon,
  Alert,
  Button,
  Row,
  Col,
  message,
} from "antd";
import "./index.css";
import * as column from "./columns";
import Graph from "./Graph";
import Photos from "./Photos";
import BoreSelect from "./BoreSelect";
import { ReportQualityPlan } from "../Reports/ReportQualityPlan";
import {
  fetchDailyLogsForProject,
  subscribeFulcrumRefresh,
} from "../../utilities/fulcrumData";

const TabPane = Tabs.TabPane;

class Bores extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBore: "",
      dailyLogs: [],
      dailyLogsLoading: false,
      dailyLogsError: null,
    };
    this.pendingDailyLogsProjectId = null;
    this.handleBoreSelect = this.handleBoreSelect.bind(this);
  }

  handleBoreSelect(projectId) {
    this.pendingDailyLogsProjectId = projectId;

    this.setState({
      selectedBore: projectId,
      dailyLogs: [],
      dailyLogsLoading: true,
      dailyLogsError: null,
    });

    ReactGA.event({
      category: this.props.user.username,
      action: "Selected bore number",
    });

    this.loadDailyLogsForProject(projectId);
  }

  BuildReport = () => {
    if (this.state.selectedBore !== "") {
      for (let i = 0; i < this.props.QualityPlans.length; i++) {
        if (this.props.QualityPlans[i].project_id === this.state.selectedBore) {
          ReportQualityPlan(this.props.QualityPlans[i]);
        }
      }
    } else {
      return message.error("Please select a job number.");
    }
  };

  componentDidMount() {
    ReactGA.pageview("/bores");
    this.unsubscribeRefresh = subscribeFulcrumRefresh(() => {
      if (this.pendingDailyLogsProjectId) {
        this.loadDailyLogsForProject(this.pendingDailyLogsProjectId);
      }
    });
  }

  loadDailyLogsForProject(projectId) {
    this.setState({ dailyLogsLoading: true, dailyLogsError: null });

    fetchDailyLogsForProject(projectId)
      .then((dailyLogs) => {
        if (this.pendingDailyLogsProjectId === projectId) {
          this.setState({ dailyLogs, dailyLogsLoading: false });
        }
      })
      .catch((err) => {
        if (this.pendingDailyLogsProjectId === projectId) {
          this.setState({
            dailyLogsError: err,
            dailyLogsLoading: false,
          });
        }
      });
  }

  componentWillUnmount() {
    this.pendingDailyLogsProjectId = null;
    if (this.unsubscribeRefresh) {
      this.unsubscribeRefresh();
    }
  }

  selectBore() {
    if (this.props.user.role === "admin") {
      return (
        <Row gutter={15}>
          <Col lg={18} sm={24} xs={24}>
            <BoreSelect
              boreList={this.props.boreList}
              onChange={this.handleBoreSelect}
            />
          </Col>
          <Col lg={6} sm={0} xs={0}>
            <Button
              type="button"
              icon="file-text"
              style={{ width: "100%" }}
              onClick={() => this.BuildReport()}
            >
              Download Quality Plan
            </Button>
          </Col>
        </Row>
      );
    } else {
      return (
        <BoreSelect
          boreList={this.props.boreList}
          onChange={this.handleBoreSelect}
        />
      );
    }
  }
  alertStatus(status, statusMessage) {
    if (status !== null) {
      return <Alert message={statusMessage} type={status} />;
    }
  }

  render() {
    let columnData = [];
    let dailyLogData = [];
    let materialData = [];
    let strataData = [];
    let photos = [];
    let status = null;
    let dailyLogs = [];
    let statusMessage = null;

    for (var i = 0; i < this.props.QualityPlans.length; i++) {
      if (this.props.QualityPlans[i].project_id === this.state.selectedBore) {
        columnData.push(this.props.QualityPlans[i]);
        if (this.props.QualityPlans[i].status === "Upcoming") {
          status = "info";
          statusMessage = "Upcoming";
        }
        if (this.props.QualityPlans[i].status === "Completed") {
          status = "success";
          statusMessage = "Completed";
        }
        if (this.props.QualityPlans[i].status === "In Progress") {
          status = "warning";
          statusMessage = "In Progress";
        }
        if (this.props.QualityPlans[i].status === "Awaiting Invoice") {
          status = "error";
          statusMessage = "Awaiting Invoice";
        }
      }
    }

    for (var k = 0; k < this.state.dailyLogs.length; k++) {
      dailyLogs.push(this.state.dailyLogs[k]);
    }
    for (var m = 0; m < dailyLogs.length; m++) {
      const date = dailyLogs[m].form_values.a709;

      if (dailyLogs[m].form_values.bbcf) {
        for (var p = 0; p < dailyLogs[m].form_values.bbcf.length; p++) {
          dailyLogData.push({
            date,
            id: dailyLogs[m].form_values.bbcf[p].id + m,
            log: dailyLogs[m].form_values.bbcf[p],
          });
        }
      }

      if (dailyLogs[m].form_values.c5d9) {
        let spliter = dailyLogs[m].form_values.c5d9.split(/\r?\n/gm);
        for (let f = 0; f < spliter.length; f++) {
          materialData.push({ id: `${date}-c5d9-${m}-${f}`, date, mat: spliter[f] });
        }
      }
      if (dailyLogs[m].form_values.fdea) {
        let spliter = dailyLogs[m].form_values.fdea.split(/\r?\n/gm);
        for (let f = 0; f < spliter.length; f++) {
          materialData.push({ id: `${date}-fdea-${m}-${f}`, date, mat: spliter[f] });
        }
      }
      if (dailyLogs[m].form_values.c4ed) {
        let spliter = dailyLogs[m].form_values.c4ed.split(/\r?\n/gm);
        for (let f = 0; f < spliter.length; f++) {
          materialData.push({ id: `${date}-c4ed-${m}-${f}`, date, mat: spliter[f] });
        }
      }
      if (dailyLogs[m].form_values["384c"]) {
        let spliter = dailyLogs[m].form_values["384c"].split(/\r?\n/gm);
        for (let f = 0; f < spliter.length; f++) {
          materialData.push({ id: `${date}-384c-${m}-${f}`, date, mat: spliter[f] });
        }
      }
      if (dailyLogs[m].form_values.c6c9) {
        for (var b = 0; b < dailyLogs[m].form_values.c6c9.length; b++) {
          strataData.push({
            id: dailyLogs[m].form_values.c6c9[b].id,
            from: dailyLogs[m].form_values.c6c9[b].form_values["95ec"],
            to: dailyLogs[m].form_values.c6c9[b].form_values["61ce"],
            strata: dailyLogs[m].form_values.c6c9[b].form_values.cbf5,
          });
        }
      }
      if (dailyLogs[m].form_values["8e1c"]) {
        for (let l = 0; l < dailyLogs[m].form_values["8e1c"].length; l++) {
          const element = dailyLogs[m].form_values["8e1c"][l];
          photos.push({
            photo_id: element.photo_id,
            client_job_number: dailyLogs[m].form_values["1647"],
          });
        }
      }
    }
    photos.reverse();
    dailyLogData.sort((a, b) => {
      var aTime = a.log.form_values["e418"];
      var bTime = b.log.form_values["e418"];
      if (a.date === b.date) {
        return aTime - bTime;
      } else {
        return a.date < b.date ? -1 : 1;
      }
    });
    dailyLogData.reverse();

    function photosTab() {
      if (photos.length !== 0) {
        return (
          <TabPane
            tab={
              <span>
                <Icon type="camera" />
                Photos
              </span>
            }
            key="5"
          >
            <Photos photoList={photos} />
          </TabPane>
        );
      } else {
        return null;
      }
    }
    function strataTab() {
      if (strataData.length !== 0) {
        return (
          <TabPane
            tab={
              <span>
                <Icon type="profile" />
                Strata
              </span>
            }
            key="3"
          >
            <Table
              pagination={false}
              id="boresTableFive"
              className="tableResizer"
              columns={column.strata}
              dataSource={strataData}
              rowKey="id"
              size="small"
            />
          </TabPane>
        );
      } else {
        return null;
      }
    }
    function diagramTab() {
      if (strataData.length !== 0) {
        return (
          <TabPane
            tab={
              <span>
                <Icon type="dot-chart" />
                Diagram
              </span>
            }
            key="4"
          >
            <Graph strataData={strataData} />
          </TabPane>
        );
      } else {
        return null;
      }
    }
    function materialsTab() {
      if (materialData.length !== 0) {
        return (
          <TabPane
            tab={
              <span>
                <Icon type="filter" />
                Materials
              </span>
            }
            key="2"
          >
            <Table
              pagination={false}
              id="boresTableFour"
              className="tableResizer"
              columns={column.materials}
              dataSource={materialData}
              rowKey="id"
              size="small"
            />
          </TabPane>
        );
      } else {
        return null;
      }
    }

    function boreDetailsSection() {
      if (!this.state.selectedBore) {
        return (
          <Alert
            message="Select a bore"
            description="Choose a bore number above to load daily logs, materials, strata, and photos."
            type="info"
            showIcon
          />
        );
      }

      if (this.state.dailyLogsError) {
        return (
          <Alert
            type="error"
            showIcon
            message="Could not load daily logs"
            description={
              this.state.dailyLogsError.message || "Please try selecting the bore again."
            }
          />
        );
      }

      const dailyLogsLoading = this.state.dailyLogsLoading;

      return (
        <Tabs defaultActiveKey="1" size="small" animated={false}>
          <TabPane
            tab={
              <span>
                <Icon type="bars" />
                Daily Log
              </span>
            }
            key="1"
          >
            <Table
              loading={dailyLogsLoading}
              pagination={false}
              id="boresTableThree"
              className="tableResizer"
              columns={column.dailyLog}
              dataSource={dailyLogData}
              rowKey="log.id"
              size="small"
            />
          </TabPane>
          {!dailyLogsLoading && materialsTab()}
          {!dailyLogsLoading && strataTab()}
          {!dailyLogsLoading && diagramTab()}
          {!dailyLogsLoading && photosTab()}
        </Tabs>
      );
    }

    return (
      <div>
        <h1>Specific Bore Details</h1>
        <h4 style={{ paddingBottom: 10 }}>
          The details, logs, and records associated with the selected bore.
        </h4>
        <div style={{ paddingBottom: 10 }} className="printHide">
          {this.selectBore()}
          {this.alertStatus(status, statusMessage)}
        </div>
        <div className="boresPadding">
          <Table
            pagination={false}
            bordered
            id="boresTableOne"
            className="boreTables tableResizer"
            columns={column.columnsOne}
            dataSource={columnData}
            rowKey="id"
            size="middle"
          />
        </div>
        <div className="boresPadding">
          <Table
            pagination={false}
            bordered
            id="boresTableTwo"
            className="boreTables tableResizer"
            columns={column.columnsTwo}
            dataSource={columnData}
            rowKey="id"
            size="middle"
          />
        </div>
        <div className="boresPadding">{boreDetailsSection.call(this)}</div>
      </div>
    );
  }
}

export default Bores;
